import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabs: [
    {
      id: 'home',
      title: 'Clients',
      path: '/home',
      type: 'page',
      closable: true,
    }
  ],
  activeTabId: 'home',
};

const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    addTab: (state, action) => {
      const { id, title, path, type, data } = action.payload;
      const existingTab = state.tabs.find(tab => tab.id === id);
      
      if (existingTab) {
        // Refresh data on reopen so re-triggering (e.g. "view calendar" for a different
        // service) applies the new params (target date, focus field, etc.) instead of keeping
        // the stale data from when the tab was first opened.
        if (data !== undefined) existingTab.data = data;
        if (title) existingTab.title = title;
        state.activeTabId = id;
      } else {
        state.tabs.push({
          id,
          title,
          path,
          type,
          data,
          closable: true,
        });
        state.activeTabId = id;
      }
    },
    closeTab: (state, action) => {
      const tabId = action.payload;
      const tabIndex = state.tabs.findIndex(tab => tab.id === tabId);
      
      if (tabIndex !== -1 && state.tabs[tabIndex].closable) {
        state.tabs.splice(tabIndex, 1);
        
        // If closing active tab, switch to another tab
        if (state.activeTabId === tabId) {
          if (state.tabs.length > 0) {
            // Switch to previous tab or first tab
            const newIndex = Math.max(0, tabIndex - 1);
            state.activeTabId = state.tabs[newIndex].id;
          } else {
            // If no tabs left, recreate the home tab
            state.tabs.push({
              id: 'home',
              title: 'Clients',
              path: '/home',
              type: 'page',
              closable: true,
            });
            state.activeTabId = 'home';
          }
        }
      }
    },
    setActiveTab: (state, action) => {
      state.activeTabId = action.payload;
    },
    closeAllTabs: (state) => {
      // Close all tabs and recreate the home tab
      state.tabs = [
        {
          id: 'home',
          title: 'Clients',
          path: '/home',
          type: 'page',
          closable: true,
        }
      ];
      state.activeTabId = 'home';
    },
    closeOtherTabs: (state, action) => {
      const keepTabId = action.payload;
      state.tabs = state.tabs.filter(tab => !tab.closable || tab.id === keepTabId);
      state.activeTabId = keepTabId;
    },
  },
});

export const { addTab, closeTab, setActiveTab, closeAllTabs, closeOtherTabs } = tabsSlice.actions;
export default tabsSlice.reducer;
